import React from "react";
import TabbedPage from "../shared/TabbedPage";
import translate from "../../../../i18n/translate";
import WhatsAppSettings from "../WhatsAppSettings";
import AdvertisementSettings from "../AdvertisementSettings";
import CompanySettings from "../../Companies/CompanySettings";

// Everything that reaches a seller's phone or screen.
const MessagingPage = ({ defaultTab }) => (
  <TabbedPage
    id="messaging"
    title={translate("Messaging")}
    intro={translate("messagingHint")}
    defaultTab={defaultTab}
    tabs={[
      { key: "whatsapp", label: "WhatsApp", render: () => <WhatsAppSettings /> },
      { key: "notifications", label: translate("Web Notifications"), render: () => <CompanySettings companyId="notifications" /> },
      { key: "msg_api", label: translate("Massaging System"), render: () => <CompanySettings companyId="msg_api" /> },
      { key: "ads", label: translate("Advertisement"), render: () => <AdvertisementSettings /> },
    ]}
  />
);

export default MessagingPage;
